import { render } from "./WhatsApp.vue?vue&type=template&id=b848b32a&scoped=true"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"

import "./WhatsApp.vue?vue&type=style&index=0&id=b848b32a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b848b32a"]])

export default __exports__